import * as React from 'react';
import Button from '../../../../../common/components/Button';
import {GLOBAL, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {BureauQueryErrorProps} from '../../../../types/mx/farrera/components';

class FileFailedUploadErrorView extends React.Component<BureauQueryErrorProps, {}> {

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container">
                            <div className="row d-flex justify-content-center mb-5 mt-3">
                                <img src={AssetsManager('/assets/images/common/warning-icon-red.svg')}
                                     width="64" height="58"/>
                            </div>
                            <div className="row p-none d-flex justify-content-center mb-3">
                                <h3 className="text-poppins text-secondary-lighten-1">
                                    Error en carga de archivo
                                </h3>
                            </div>
                            <div className="row p-none d-flex justify-content-left pb-4 border-bottom">
                                <p className="regular-text">Por favor revisa que el archivo a cargar: sea del formato (JPG, PNG o PDF) y tamaño (menor a 10MB) correcto. Además revisa que no estés subiendo un archivo con un nombre repetido.</p>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 d-flex justify-content-center">
                                    <Button text={GLOBAL.CONTINUE} onPress={this.props.onPressNext}
                                            customClass="px-md-5" type={'outlined'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default FileFailedUploadErrorView;
